import {MegaphoneMini} from '@dropbox/dig-illustrations';
import {EmptyState} from 'components/DSYS/EmptyState';
import {t} from 'i18next';

export const DashboardEmptyState = ({onCustomize}: {onCustomize?: () => void}) => (
  <EmptyState
    hideBorder
    title={t('dashboard_empty_title')}
    body={t('dashboard_empty_body')}
    image={<MegaphoneMini width={64} altText={t('dashboard_empty_title')} />}
    cta={onCustomize ? {text: t('dashboard_customize_title'), onClick: onCustomize} : undefined}
  />
);
